import { render, staticRenderFns } from "./trans-nav-list.html?vue&type=template&id=52932025&scoped=true&external"
import script from "./trans-nav-list.js?vue&type=script&lang=js&external"
export * from "./trans-nav-list.js?vue&type=script&lang=js&external"
import style0 from "./trans-nav-list.scss?vue&type=style&index=0&id=52932025&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52932025",
  null
  
)

export default component.exports